import "./App.css";
import Form from "./Form"; 
import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom";
import LoginPage from "./Login";
import StudentReceipt from "./StudentReceipt";
import React, { useEffect } from "react";
import AdminReceipt from "./AdminReceipt";
import StudentDetails from "./StudentDetails";

export default function App() {
  useEffect(() => {
    sessionStorage.getItem("loggedIn");
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/armedforces" element={<Form />} />
        <Route path="/armedforces/student-details" element={<StudentDetails />} />
        <Route
          path="/armedforces/admin/donationReceipt/:transaction_id"
          element={<AdminReceipt />}
        />
        <Route
          path="/armedforces/donationReceipt/:transaction_id"
          element={<StudentReceipt />}
        />

        <Route path="/armedforces/login" element={<LoginPage />} />
      </Routes>
    </BrowserRouter>
  );
}
